import { Input as ChakraInput } from "@chakra-ui/react";
import type { ComponentPropsWithRef } from "react";

export type InputProps = ComponentPropsWithRef<typeof ChakraInput>;

export function Input(props: InputProps) {
  return <ChakraInput {...props} />;
}
